module.exports = __webpack_public_path__ + "static/media/logo-small.ab133dc4.jpg";